var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.libraryCoach)?_c('div',{staticClass:"gate-wrap"},[_c('coach-required')],1):_c('statistics-view',{key:_vm.libraryCoach.id})
}
var staticRenderFns = []

export { render, staticRenderFns }